import axios from 'axios';
// import authHeader from './auth-header';
import User from '@/assets/json/user.json'
var path =  require('@/assets/json/path.json')
const API_URL = `${path.api}/auth`;

class AuthService {
  login(user) {
    let data = User
    data.user.username = user.username
    localStorage.setItem('user', JSON.stringify(data));
    return Promise.resolve(data);
    // return axios
    //   .post(API_URL + '/login/', {
    //     username: user.username,
    //     password: user.password
    //   })
    //   .then(response => {
    //     if (response.data.token) {
    //       localStorage.setItem('user', JSON.stringify(response.data));
    //     }
    //     return response.data;
    //   });
  }

  logout() {
    localStorage.removeItem('user');
    // axios.post(API_URL+'/logout/',{}, { headers: authHeader() })
    //   .then(() => {
    //     localStorage.removeItem('user');
    //   })
    //   .catch(() => {
    //     localStorage.removeItem('user');
    //   })
  }

  register(user) {
    return axios.post(API_URL + '/signup/', {
      username: user.username,
      email: user.email,
      first_name: user.first_name,
      last_name: user.last_name,
      password1: user.password,
      password2: user.re_password
    });
  }
}

export default new AuthService();